export enum MediaSourceEnum {
  DRAWER,
  SECTION,
  CAROUSEL,
  CAROUSEL_STATIC,
}
